// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Xc5Y4","children":"styles_children__2v-Vo","message":"styles_message__1jENh"};